import React from "react";
import { Navigate, useParams } from "react-router";

import SingleTopics from "./SingleTopics";
import LoadingSpinner from "../../common/LoadingSpinner";

import { useAppSelector } from "../../redux/hooks";
import { getAuthToken } from "../../redux/reducers/auth";

import { useMetaData } from "../../utils/useMetaData";
import { useGetTopics } from "../../utils/useTopics";
import OtherTopicsContainer from "./OtherTopicsContainer";

const SingleTopicsContainer: React.FC = () => {
  const { id } = useParams<{ id: string }>();

  const auth_token = useAppSelector(getAuthToken);

  const {
    topicsData: { items: topic },
    isLoading: isLoading,
  } = useGetTopics({
    auth_token: auth_token,
    id: id,
  });

  useMetaData(
    topic?.[0]
      ? {
          title: topic[0].name,
          description: "",
          imgUrl: topic[0].imgs?.[0]?.medium?.url ?? "",
        }
      : undefined
  );

  if (isLoading === true) {
    return <LoadingSpinner space={1} />;
  } else if (topic && topic[0]?.id == id) {
    return (
      <SingleTopics
        imgSrc={topic[0].imgs?.[0]?.large?.url}
        type={topic[0].topic_type?.name}
        date={topic[0].start_date}
        title={topic[0].name}
        tags={topic[0].tags}
        game={topic[0].game}
        content={topic[0].content?.blocks}
        authorName={topic[0].author_name}
        relatedContents={
          <OtherTopicsContainer
            emitId={id}
            typeName={topic[0].topic_type?.name}
          />
        }
      />
    );
  } else {
    return <Navigate to="/404" replace />;
  }
};

export default SingleTopicsContainer;
